<template>
  <div>
    <v-row no-gutters> Menu </v-row>
    <v-row>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  Dropdown
                </v-btn> -->
                  <a-btn color="primaryDark" v-bind="attrs" v-on="on">
                    ラベル <v-icon>mdi-chevron-down</v-icon></a-btn
                  >
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in items" :key="index">
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </a-menu>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn color="secondary" small v-bind="attrs" v-on="on">
                    ラベル <v-icon>mdi-chevron-down</v-icon></a-btn
                  >
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in items" :key="index">
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </a-menu>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ABtn from "./ABtn.vue";
import AMenu from "./AMenu.vue";
export default {
  components: { AMenu, ABtn },
  name: "MenuSample",
  data() {
    return {
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
    };
  },
};
</script>

<style scoped>
.card-div {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='black' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}
</style>